import {useNavigate, useParams} from "react-router-dom";
import {Container, Paper, Typography} from "@mui/material";
import ReviewForm from "../components/ReviewForm.tsx";
import {useContext} from "react";
import ReviewContext from "../contexts/ReviewContext.tsx";

const EditReviewPage = () => {
    const {orderId, reviewId} = useParams();
    const {reviews} = useContext(ReviewContext);
    const navigate = useNavigate();

    const review = reviews?.find((review) => review._id === reviewId);

    if (!orderId) return <Typography>Ungültige Bestell-ID</Typography>;

    if (!review) {
        return <Typography>Review Not Found</Typography>
    }

    return (
        <Container sx={{padding: '12px'}}>
            <Paper
                elevation={4}

                sx={{
                    maxWidth: '900px',
                    margin: 'auto',
                    padding: 2,
                }}
            >
                <Typography variant="h5" sx={{mb: 2}}>
                    Bewertung schreiben
                </Typography>
                <ReviewForm
                    orderId={orderId}
                    existingReview={review}
                    onReviewSubmit={() => navigate("/profile")}
                />
            </Paper>
        </Container>
    );
}

export default EditReviewPage;